import Link from "next/link";
import React from "react";

interface ButtonProps {
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  name?: string|any;
  path?: string;
  type?: "reset" | "button" | "submit";
  click?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  icon,
  className,
  disabled,
  name,
  path,
  type,
  click,
}) => {
  const commonClasses = `px-4 py-3 ${className} bg-slate-200 text-sm lg:text-base text-slate-800 rounded-md flexer gap-3 scale-100 hover:scale-105 active:scale-90 duration-100`;

  if (path) {
    return (
      <Link href={path} className={commonClasses}>
        {icon}
        {name}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={click}
      className={commonClasses}
      disabled={disabled}
    >
      {icon}
      {name}
    </button>
  );
};

export default Button;
